import React from "react";

import { Container, Row, Col } from 'react-bootstrap';

import AuthorizationChecker from '../../services/AuthorizationChecker';
import TooltipInfo from '../../components/widgets/tooltipInfo/TooltipInfo';
import GlobalStatComponent from "../../components/stats/GlobalStatComponent";
import CustomTabsWithParams from "../../components/widgets/customTabs/CustomTabsWithParams";
import WebappGlobalStatComponent from "../../components/stats/WebappGlobalStatComponent";
import WebappAdminStatComponent from "../../components/stats/WebappAdminStatComponent";
import HeadsetsStatComponent from "../../components/stats/HeadsetsStatComponent";
import HeadsetEventsStatComponent from "../../components/stats/HeadsetEventsStatComponent";

const StatPage = () => {
    const contentTabs = [
        {
            eventKey: "globalStat",
            title: "Général",
            mountOnEnter: true,
            unmountOnExit: false,
            content: <GlobalStatComponent />
        },
        {
            eventKey: "webappGlobalStat",
            title: "Webapp - général",
            mountOnEnter: true,
            unmountOnExit: false,
            content: <WebappGlobalStatComponent />
        },
        {
            eventKey: "webappAdminStat",
            title: "Webapp - admin",
            mountOnEnter: true,
            unmountOnExit: false,
            content: <WebappAdminStatComponent />
        },
        {
            eventKey: "headsetsStat",
            title: "Parc de casques",
            mountOnEnter: true,
            unmountOnExit: false,
            content: <HeadsetsStatComponent />
        },
        {
            eventKey: "headsetEventsStat",
            title: "Navigation dans les casques",
            mountOnEnter: true,
            unmountOnExit: false,
            content: <HeadsetEventsStatComponent />
        }
    ];

    return <Container fluid>
        <Row>
            <Col>
                <h2 className='d-flex'>
                    Statistiques
                    {!AuthorizationChecker.isAdmin()
                        && <TooltipInfo description='Quelles sont les expériences immersives les plus regardées sur votre parc de casques. 
                        Télécharger le détail au format csv.' />}
                </h2>
            </Col>
        </Row>
        {AuthorizationChecker.isAdmin()
            ? <CustomTabsWithParams
                contentTabs={contentTabs}
                defaultActiveTabId="globalStat"
                id="stats-tabs"
                className="mt-0"
            />
            : <GlobalStatComponent />
        }
    </Container>;
}

export default StatPage;